$('.fa-topbar-text').owlCarousel({
    loop: false,
    margin: 0,
    nav: false,
    dots: false,
    animateOut: 'animate__fadeOutUp',
    animateIn: 'animate__fadeInUp',
    responsive: {
      0: {
        items: 1,
        loop: true,
        autoWidth: false,
        nav: true,
        autoplay: true,
        autoplayTimeout: 3000,
      },
      630: {
        items: 4,
        autoWidth: true,
      }
    }
})
/*=============================================Top Bar============================================================*/
// function initTopbarCarousel() {
//   const $carousel = $('.fa-topbar-text');

//   if ($carousel.hasClass('owl-loaded')) {
//     $carousel.trigger('destroy.owl.carousel');
//     $carousel.removeClass('owl-loaded owl-theme');
//     $carousel.find('.owl-stage-outer').children().unwrap();
//     $carousel.find('.owl-item').children().unwrap();
//   }

//   $carousel.owlCarousel({
//     loop: false,
//     margin: 0,
//     nav: false,
//     dots: false,
//     animateOut: 'animate__fadeOutUp',
//     animateIn: 'animate__fadeInUp',
//     responsive: {
//       0: {
//         items: 1,
//         loop: true,
//         autoWidth: false,
//         nav: true,
//         autoplay: true,
//         autoplayTimeout: 3000,
//       },
//       630: {
//         items: 4,
//         autoWidth: true,
//       }
//     }
//   });
// }

// $(document).ready(function () {
//   initTopbarCarousel();

//   // Optional: debounce resize reinit
//   let resizeTimer;
//   $(window).on('resize', function () {
//     clearTimeout(resizeTimer);
//     resizeTimer = setTimeout(() => {
//       initTopbarCarousel();
//     }, 300);
//   });
// });
/*=============================================Announcement Bar============================================================*/
$('.fa-announcementbar-text').owlCarousel({
    loop: false,
    margin: 0,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 1,
        loop: true,
        autoWidth: false,
        nav: true,
        autoplay: true,
        autoplayTimeout: 3000,
      },
      630: {
        items: 3,
        autoWidth: true,
      }
    }
})
/*=============================================Product SLIDER============================================================*/
$('.fa-product-carousel').owlCarousel({
    loop:true,
    margin:15,
    nav:true,
    dots: false,
    responsive:{
        0:{
            items:1,
        },
        430:{
            items:2
        },
        860:{
            items:3
        },
        1320:{
            items:4
        }
    }
})
/*==============================================FAQ============================================================*/
document.querySelectorAll('.fa-accordian-question-flex').forEach(function(question) {
  question.addEventListener('click', function() {
    // Find the parent .fa-accordian-question
    const parent = question.closest('.fa-accordian-question');
    
    // Find the .fa-accordian-answer within the parent
    const answer = parent.querySelector('.fa-accordian-answer');
    
    // Check if the answer is currently visible or hidden
    if (answer.style.display === 'none' || answer.style.display === '') {
      // Show the answer
      answer.style.display = 'block'; // Make it visible
      setTimeout(() => { // Delay to allow display to be applied
        answer.style.opacity = '1'; // Fade in
        answer.style.maxHeight = '500px'; // Expand the content
      }, 10); // Small delay for browser to reflow after setting display: block
      parent.classList.add('open'); // Add the 'open' class to rotate the arrow
    } else {
      // Add delay before starting opacity and height collapse
      setTimeout(() => {
        // Fade out and collapse content
        answer.style.opacity = '0'; // Fade out
        answer.style.maxHeight = '0px'; // Collapse content to height 0
      }, 10); // Small delay for opacity and height transition

      // Delay the setting of display: none until after transition completes
      setTimeout(() => {
        answer.style.display = 'none'; // Remove the content from flow after transition
      }, 300); // Delay to match transition time (300ms)
      
      parent.classList.remove('open'); // Remove the 'open' class to reset the rotation
    }
  });
});
